import { Routes } from '@angular/router';
import { AdministrationDashboardComponent } from './components/administration-dashboard.component';

export const administrationRoutes: Routes = [
  {
    path: 'administration',
    component: AdministrationDashboardComponent,
    data: {
      title: 'Administration',
      isNav:  true,
      icon: 'supervisor_account',
      permissions: ['SubmissionModule.SubmittingEntity:View', 'CustomerModule.Users:View', 'CustomerModule.Groups:View', 'ConfigurationModule.Messages:View']
    },
    children: [
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/administration/routes.config.ts